// @ts-nocheck
import PropTypes from "prop-types";
import {User, CurrencyCircleDollar, PaperPlaneTilt} from "@phosphor-icons/react";
import {useTranslation} from "react-i18next";

const ConfirmRow = ({icon, label, value, highlight}) => (
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      maxWidth: 380,
      padding: "12px 16px",
      borderRadius: 12,
      background: "rgba(215,50,168,0.07)",
      border: "1px solid rgba(215,50,168,0.18)",
    }}
  >
    <div style={{display: "flex", alignItems: "center", gap: 8}}>
      {icon}
      <span style={{fontWeight: 600, fontSize: 14, color: "rgba(255,255,255,0.7)"}}>{label}</span>
    </div>
    <span
      style={{
        fontWeight: 700,
        fontSize: 15,
        color: highlight ? "#d732a8" : "#fff",
        textAlign: "right",
        wordBreak: "break-word",
      }}
    >
      {value}
    </span>
  </div>
);

const TransferConfirm = ({transferContact, transferAmount}) => {
  const {t} = useTranslation();

  return (
    <div style={{display: "flex", flexDirection: "column", alignItems: "center", gap: 12, padding: "8px 0 8px"}}>
      {/* Title */}
      <h4
        style={{
          fontWeight: 700,
          fontSize: 16,
          margin: "0 0 4px",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          gap: 8,
        }}
      >
        <PaperPlaneTilt size={20} color="#d732a8" weight="fill" />
        {t("transferSteps_3_Confirm")}
      </h4>

      <ConfirmRow
        icon={<User size={18} color="#d732a8" weight="fill" />}
        label={`${t("transferSteps_3_Beneficiary")}:`}
        value={transferContact?.name ?? "—"}
      />
      <ConfirmRow
        icon={<CurrencyCircleDollar size={18} color="#d732a8" weight="fill" />}
        label={`${t("transferSteps_3_Amount")}:`}
        value={`Bs. ${transferAmount}`}
        highlight
      />

      {/* Divider hint */}
      <p style={{fontSize: 12, color: "rgba(255,255,255,0.35)", margin: "4px 0 0", textAlign: "center"}}>
        Revisa los datos antes de confirmar
      </p>
    </div>
  );
};

TransferConfirm.propTypes = {
  transferContact: PropTypes.object.isRequired,
  transferAmount: PropTypes.number.isRequired,
};

export default TransferConfirm;
